import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

// Import all the routes
import rootRoute from "./root.route";
import albumRoutes from './album.route';
import api from "@/api";


const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        ...rootRoute,
        ...albumRoutes
    ],
})


// Navigation Guards를 이용한 권한 체크
router.beforeEach(async (to, from, next) => {
    console.log(`[route] ${to.name} ${to.path}`);

    // 페이지 권한 체크
    try {
        await api.auth.checkPageAuth(to.name, to.path);
        next();
    } catch (e) {
        alert('권한이 없는 페이지입니다. 메인화면으로 이동합니다.');
        next("/");
    }

});

export default router
